import {createContext} from 'react';

const ThemeContext = createContext({
  primaryColor: '#4f7e32',
  secondaryColor: '#54327e',
});

export default ThemeContext;
